
import { generateQueryParams } from 'utils/interfaces';
import CommonService from './common.service';

class NotificationService extends CommonService {
	async getNotifications(params?: { [key: string]: string | boolean }) {
		const query = generateQueryParams(params);
		return await this.get(`notifications/?${query}`);
	}
	async getNotificationDetails(id: string) {
		return await this.get(`notifications/${id}`)
	}
	async createNotification(parmas: { [key: string]: boolean | string }) {
		return await this.post('notifications', parmas)
	}
	async updateNotification(id: string, params: { [key: string]: boolean | string }) {
		return await this.put(`notifications/${id}`, params)
	}
	async deleteNotification(id: string) {
		return await this.delete(`notifications/${id}`)
	}
	
}
export const notificationService = new NotificationService();
